import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../../store'
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from './notificationActions'
import { AdBreak } from 'common/api/v1/types'
import { AdBreaksRequestParams, EnrichedAdBreak } from '../../api/nm-types'
import { ListResult } from 'common/api/v1/types'

export const listAdBreaks = createAsyncThunk<ListResult<EnrichedAdBreak>, AdBreaksRequestParams, ThunkApi>(
  'adBreaks/listAdBreaks',
  async (params, { dispatch, extra: { api } }) => {
    try {
      return await api.adBreaksApi.listAdBreaks(params)
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'fetch Ad Breaks' }))
      throw error
    }
  },
)

export const getAdBreak = createAsyncThunk<AdBreak, string, ThunkApi>(
  'adBreaks/getAdBreak',
  async (id, { dispatch, extra: { api } }) => {
    try {
      return await api.adBreaksApi.getAdBreak(id)
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'fetch Ad Break' }))
      throw error
    }
  },
)

export const deleteAdBreak = createAsyncThunk<AdBreak, string, ThunkApi>(
  'adBreaks/deleteAdBreak',
  async (id, { dispatch, extra: { api } }) => {
    try {
      const res = await api.adBreaksApi.deleteAdBreak(id)
      dispatch(enqueueSuccessSnackbar('Ad Break deleted'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'delete Ad Break' }))
      throw error
    }
  },
)

export const deleteAdBreaks = createAsyncThunk<string[], string[], ThunkApi>(
  'adBreaks/deleteAdBreaks',
  async (ids, { dispatch, extra: { api } }) => {
    try {
      for (const id of ids) {
        await api.adBreaksApi.deleteAdBreak(id)
      }
      dispatch(enqueueSuccessSnackbar('Ad Break deleted'))
      return ids
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'delete Ad Break' }))
      throw error
    }
  },
)

export const clearAdBreak = createAction('adBreaks/clearAdBreak')
export const clearAdBreaks = createAction('adBreaks/clearAdBreaks')
